module.exports = __webpack_public_path__ + "fonts/sourcesanspro.9bd66a05.woff";